<div class="vc-modal__innerContainer">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>
  <div class="vc-modal__title">Garanties légales</div>
  <div class="vc-modal__content">
    <p>
      Les vendeurs professionnels sont tenus de la garantie légale de conformité sur les produits qu’ils vendent par
      l’intermédiaire de la plateforme Vestiaire Collective.
    </p>
    <p>
      La garantie légale de conformité couvre les défauts du bien vendu qui le rendent impropre à l'usage habituellement
      attendu d'un bien semblable. La garantie vous permet d’obtenir la réparation ou le remplacement du bien. Vous
      pouvez consulter les dispositions légales applicables
      <vc-ref
        resource="https://www.legifrance.gouv.fr/affichCode.do;jsessionid=3B86451A64D67911821A3C6702207E8E.tplgfr29s_3?idSectionTA=LEGISCTA000032226943&cidTexte=LEGITEXT000006069565&dateTexte=20180206"
        [blank]="true"
        [anchor]="false"
        class="modal__legalWarrantiesLink"
        >ici</vc-ref
      >.
    </p>
    <p>
      Les vendeurs particuliers et les vendeurs professionnels sont tenus de la garantie des vices cachés sur les
      produits qu’ils vendent par l’intermédiaire de la plateforme Vestiaire Collective.
    </p>
    <p>
      La garantie des vices cachées couvre les défauts cachés du bien vendu qui le rendent impropre à l'usage auquel on
      le destine, ou qui diminuent tellement cet usage, que l'acheteur ne l'aurait pas acquis, ou n'en aurait donné
      qu'un moindre prix, s'il les avait connus. La garantie vous permet d’obtenir une réduction du prix de vente, si
      vous conservez le produit ou la restitution de la totalité du prix de vente, si vous retournez le produit au
      vendeur. Vous pouvez consulter les dispositions légales applicables
      <vc-ref
        resource="https://www.legifrance.gouv.fr/affichCode.do;jsessionid=3B86451A64D67911821A3C6702207E8E.tplgfr29s_3?idSectionTA=LEGISCTA000006165624&cidTexte=LEGITEXT000006070721&dateTexte=20180206"
        [blank]="true"
        [anchor]="false"
        class="modal__legalWarrantiesLink"
        >ici</vc-ref
      >.
    </p>
  </div>
</div>
